import React, { useState, useContext } from 'react';
import Form from 'react-bootstrap/Form';
import Weitereangabe from './Weitereangabe';
import { DataContext } from './../../App';

export default function Grundstucktyp(params) {
  let [page, setPage] = useState(0);
  const { grundstucktyp, setGrundstucktyp } = useContext(DataContext);

  let previousPage = () => {
    setPage(0);
  };

  return (
    <>
      {page === 0 && (
        <>
          <h2>
            <strong>UM WAS FÜR EIN GRUNDSTÜCKTYP HANDELT ES SICH?</strong>
            <hr />
          </h2>

          <div className='choices-list-one'>
            <div className='choice'>
              <Form.Select
                aria-label='Default select example'
                value={grundstucktyp}
                onChange={(e) => setGrundstucktyp(e.target.value)}
              >
                <option value='BAULAND ERSCHLOSSEN'>BAULAND ERSCHLOSSEN</option>
                <option value='BAULAND NICHT ERSCHLOSSEN'>
                  BAULAND NICHT ERSCHLOSSEN
                </option>
                <option value='ACKERLAND'>ACKERLAND</option>
                <option value='WALD / GRÜNLAND'>WALD / GRÜNLAND</option>
              </Form.Select>
              <p>GRUNDSTÜCKTYP</p>
            </div>
          </div>
          <div className='buttons'>
            <button className='previous' onClick={params.previousPage}>
              Zurück
            </button>
            <button className='next' onClick={() => setPage(1)}>
              Weiter
            </button>
          </div>
        </>
      )}
      {page === 1 && (
        <Weitereangabe
          data={{ grundstucktyp, ...params.data }}
          previousPage={previousPage}
        />
      )}
    </>
  );
}
